import Tree from './src/tree.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElTree = withInstall(Tree);

export { ElTree, ElTree as default };
//# sourceMappingURL=index.mjs.map
